import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSignal } from "@preact/signals-react";
import type { VirtuosoHandle } from "react-virtuoso";

interface VirtualListProps {
  children: React.ReactNode;
  containerHeight?: number | string;
}

const VirtualList = React.forwardRef<VirtuosoHandle, VirtualListProps>(
  ({ children, containerHeight = "500px" }, ref) => {
    const virtuosoModule = useSignal<any | null>(null);
    useEffect(() => {
      const loadModules = async () => {
        await import("ag-charts-enterprise");
        const { Virtuoso } = await import("react-virtuoso");
        virtuosoModule.value = Virtuoso;
      };

      loadModules();
    }, []);
    const Virtuoso = virtuosoModule.value;

    const childrenArray = React.Children.toArray(children);
    const onFollowOutputHandler = (atBottom: boolean) => {
      return atBottom ? "auto" : false;
    };

    const getContainerHeight = () => {
      // if can convert containerHeight into number return it
      const height = Number(containerHeight);
      if (!isNaN(height)) {
        return height;
      }
      return containerHeight;
    };

    return (
      <Box sx={{ height: getContainerHeight(), width: "auto" }}>
        {Virtuoso ? (
          <Virtuoso
            ref={ref}
            followOutput={onFollowOutputHandler}
            style={{ height: "100%", width: "100%" }}
            totalCount={childrenArray.length}
            initialTopMostItemIndex={0}
            itemContent={(index) => <Box key={index}>{childrenArray[index]}</Box>}
          />
        ) : (
          <div>Loading...</div>
        )}
      </Box>
    );
  }
);

export default VirtualList;
